import React, { memo, useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { ParamsAndReturnTypes } from '@prisjakt/ui-translate/src/translate-func';
import StockStatus from '@prisjakt/ui-stock-status';

import { StockStatusStates } from '@prisjakt/ui-stock-status/src/types';
import { ProductPriceType } from '../../../../areas/product/types';
import { Price } from '../../../../types';

import Icon from './components/stock-status-icon';
import PriceNotice from '../price-notice';

import * as S from './styles';

type OwnProps = {
  className?: string;
  status?: StockStatusStates | null;
  statusText?: string | null;
  toneDown?: boolean;
  countryCode?: string | null;
  isInternationalPrice?: boolean;
  priceType?: ProductPriceType | null;
  deliveryOptions?: Price['deliveryOptions'];
  width?: number;
};

const StockStatusColumn = ({
  className,
  status,
  statusText,
  toneDown = false,
  countryCode,
  isInternationalPrice = false,
  priceType,
  deliveryOptions = [],
  width,
}: OwnProps) => {
  const { t, market } = useContext(AppContext);
  const processedStatusText = statusText
    ? statusText.replace(/-/g, '\u2011') /* no-breaking hyphen in dates */
    : t(
        'product',
        `stock-status.${status ||
          'unknown'}` as keyof ParamsAndReturnTypes['product']
      );

  const homeDelivery =
    deliveryOptions &&
    deliveryOptions.find(option => option && option.type === 'HOME_DELIVERY');

  return (
    <div className={className}>
      {priceType && priceType !== ProductPriceType.NORMAL ? (
        <Icon
          icon={
            <PriceNotice
              type={priceType as NonNullable<ProductPriceType>}
              hideText
            />
          }
          tooltipText={t(
            'product',
            `price-notice.${priceType}` as keyof ParamsAndReturnTypes['product']
          )}
          showTooltip
        />
      ) : null}
      {homeDelivery && (
        <Icon
          icon={
            <S.HomeDeliveryIcon
              src={`${market.cdn}/rfe/g/home-delivery.e5660c.svg`}
            />
          }
          tooltipText={t(
            'product',
            `home-delivery.info` as keyof ParamsAndReturnTypes['product']
          )}
          showTooltip
        />
      )}
      {countryCode && (
        <S.CountryFlag
          show={isInternationalPrice}
          countryCode={countryCode}
          title={t(
            'common',
            `market.${countryCode}` as keyof ParamsAndReturnTypes['common']
          )}
          tooltipPlacement="top"
        />
      )}
      <Icon
        icon={
          <StockStatus
            status={status}
            toneDown={toneDown}
            tooltip={processedStatusText as string}
            tooltipPlacement="top"
            width={width}
          />
        }
      />
    </div>
  );
};

export default memo(StockStatusColumn);
